import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import useMediaQuery from "app/hooks/useMediaQuery";

import "./CreditInfo.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;

const CreditInfo = ({ credito, borderTopColor, ...props }) => {
  const [meta, setMeta] = useState({});
  const [itemsBreadcrumb, setItemsBreadcrumb] = useState([]);
  const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });
  const [btnSolicite, setBtnSolicite] = useState({});
  const [btnCalcule, setBtnCalcule] = useState({});

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const getCorrectImageSize = (listImages) => {
    let cls = "";
    if (isIphoneLandscape) {
      cls = listImages.imagen3x.urls[0];
    } else if (isIpadPortrait) {
      cls = listImages.imagen2x.urls[0];
    } else if (isDesktop) {
      cls = listImages.imagen.urls[0];
    }
    return cls;
  };

  const getWidthTitle = () => {
    if (isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "178",
        maxWidth: "100%",
        width: "fit-content",
      });
    } else if (isIpadPortrait || isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "225px",
        maxWidth: "75%",
        width: "fit-content",
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(credito.btnSolicite)) {
      setBtnSolicite({
        url: credito.btnSolicite.url,
        alt: credito.btnSolicite.alt,
        img: ROOT + getCorrectImageSize(credito.btnSolicite.images),
      });
    }
    if (!isEmpty(credito.btnCalcule)) {
      setBtnCalcule({
        url: credito.btnCalcule.url,
        alt: credito.btnCalcule.alt,
        img: ROOT + getCorrectImageSize(credito.btnCalcule.images),
      });
    }
    getWidthTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isDesktop,
    isIpadPortrait,
    isIphoneLandscape,
    credito.btnSolicite,
    credito.btnCalcule,
  ]);

  useEffect(() => {
    if (!isEmpty(credito)) {
      setMeta((m) => {
        return {
          ...m,
          title: credito.title,
          description: credito.description,
          url: `/${credito.id}`,
        };
      });

      if (credito.prevRoute) {
        setItemsBreadcrumb([
          {
            url: credito.prevRoute[0].url,
            text: credito.prevRoute[0].text,
          },
        ]);
      } else {
        setItemsBreadcrumb([{ url: `${credito.id}`, text: credito.title }]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credito]);

  const buttons = (
    <div className="w-100">
      <div className="button-container">
        {!isEmpty(btnSolicite) && (
          <div className="cmsButton">
            <a
              className="anchor"
              href={btnSolicite.url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="img"
                src={btnSolicite.img}
                alt={btnSolicite.alt}
              />
            </a>
          </div>
        )}
        {!isEmpty(btnCalcule) && (
          <div className="cmsButton">
            <a className="anchor" href={btnCalcule.url}>
              <img className="img" src={btnCalcule.img} alt={btnCalcule.alt} />
            </a>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Meta
        title={meta?.title + " | Créditos | CS Ahorro y Crédito"}
        description={meta?.description}
        canonicalUrl={meta?.url}
      />
      <Breadcrumbs items={itemsBreadcrumb} active={meta?.title} />
      <div className="credit-container">
        <div className="w-100 d-flex flex-column align-items-start text-left">
          <h1 className="credit-title">{credito.title}</h1>
          <span className="credit-description">
            {Parser(credito.description)}
          </span>
        </div>
        <div className="w-100">
          {credito.details &&
            credito.details.map((detail, index) => (
              <CardTypeFolder
                key={index}
                titleStyle={detailTitleStyle}
                title={detail.title}
                description={detail.description.html}
                borderTopColor={borderTopColor}
              />
            ))}
        </div>
        {buttons}
      </div>
    </>
  );
};

CreditInfo.propTypes = {
  credito: PropTypes.object.isRequired,
  borderTopColor: PropTypes.string,
};

export default CreditInfo;
